import { ChatStore, setChat } from "store/Chat";
import { QueryClient, useMutation, useQuery } from "react-query";
import {
  child,
  get,
  getDatabase,
  limitToLast,
  onChildAdded,
  push,
  query,
  ref,
  update,
} from "firebase/database";
import { getChatUuid, getUserUuid } from "functions/uuid";

import { AxiosError } from "axios";
import { ChatMessage } from "interfaces/Chat";
import { Dispatch } from "redux";
import axios from "config/axios";
import { v4 as uuidV4 } from "uuid";

export const getMessages = async (
  chatUuid: string,
  queryClient: QueryClient,
  userId: string
): Promise<ChatMessage[]> => {
  try {
    const dbRef = ref(getDatabase());
    const snap = await get(child(dbRef, `/chats/${chatUuid}`));
    watchMessages(chatUuid, queryClient, userId);
    const values: ChatMessage[] = Object.values(snap.val() || {});
    Object.keys(snap.val() || {}).forEach((e) => {
      if (snap.val()[e] !== userId) {
        update(ref(getDatabase(), `/chats/${chatUuid}/${e}`), { read: true });
      }
    });
    return values;
  } catch (error) {
    console.log(error, "error");
    throw error;
  }
};

export const useMessages = (
  chatUuid: string,
  queryClient: QueryClient,
  userId: string
) =>
  useQuery(
    ["chat", chatUuid],
    async () => getMessages(chatUuid, queryClient, userId),
    {
      staleTime: Infinity,
      retry: false,
    }
  );

export const watchMessages = (
  chatUuid: string,
  queryClient: QueryClient,
  userId: string
) => {
  const db = getDatabase();
  console.log("Called");
  onChildAdded(query(ref(db, `/chats/${chatUuid}`), limitToLast(1)), (snap) => {
    const val: ChatMessage = snap.val();
    console.log(val, "val");
    //Marca as mensagens como lida se não a mensagem não for do próprio usuário

    queryClient.setQueryData<ChatMessage[]>(
      ["chat", chatUuid],
      (oldData = []) => {
        if (val && !oldData.find((e) => e._id === val._id)) {
          if (val.user._id !== userId) {
            update(snap.ref, { read: true });
          }
          return [...oldData, val];
        }
        return oldData;
      }
    );
  });
};

export const sendMessage = (
  message: string,
  chatStore: ChatStore,
  chatUuid: string
) => {
  const db = getDatabase();
  const formatedMessage: ChatMessage = {
    _id: uuidV4(),
    user: {
      _id: chatStore.user._id,
      name: chatStore.user.name,
      email: chatStore.user.email,
    },
    message,
    read: false,
    date: new Date().getTime(),
  };
  push(ref(db, `/chats/${chatUuid}`), formatedMessage);
};

const handleCreateChat = async (values: {
  email: string;
  name: string;
  uuid: string;
}) => {
  return axios.post("/chat/create", values);
};

export const useCreateChat = (dispatch: Dispatch) =>
  useMutation(handleCreateChat, {
    onSuccess: async (data, variables) => {
      dispatch(
        setChat({
          user: {
            name: variables.name,
            _id: getUserUuid() ?? uuidV4(),
            email: variables.email,
          },
          uuid: getChatUuid() ?? variables.uuid,
        })
      );
    },
    onError: async (
      error: AxiosError<{ error: string; status: number }, any> | undefined
    ) => {
      try {
        console.log(error);
        return window.alert("Problema ao iniciar chat");
      } catch (error) {
        console.log(error);
      }
    },
  });
